<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
    size="lg"
    @shown="shown = true"
    @hidden="shown = false"
  >
    <b-form-group label="Name:">
      <b-form-input
        v-model="$v.name.$model"
        :class="{ 'is-invalid': $v.name.$error }"
        :disabled="inProgress"
        @keydown.space.prevent
        autocomplete="off"
        @keydown.ctrl.83.native.prevent="submit"
      />
      <b-form-invalid-feedback
        v-if="!$v.name.required"
      >
        Name is required
      </b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.name.alphaNum"
      >
        Name accepts only alphanumerics
      </b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.name.isUnique"
      >
        Component with the same name already exists
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Code:">
      <div class="templateEditor">
        <codemirror
          v-if="shown"
          :value="code"
          :options="cmOptions"
          @input="onCmCodeChange"
          @keydown.ctrl.83.native.prevent="submit"
        />
      </div>
    </b-form-group>
    <div>
      <b-button
        variant="primary"
        @click="submit"
      >
        Save
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import httpVueLoader from "http-vue-loader";
import { required, helpers } from 'vuelidate/lib/validators'
const alphaNum = helpers.regex('alphaNum', /^[a-zA-Z0-9_-\s]*$/)
// helpers
import constants from '@/helpers/constants'
// services
import db from '@/services/db'

export default {
  props: {
    title: {
      type: String,
      default: 'Create New Component'
    },
    components: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      editKey: null,
      inProgress: false,
      shown: false,
      name: null,
      code: `<template>\n\t<div>\n\t</div>\n</template>\n`,
      cmOptions: constants.cmTemplateOptions
    }
  },
  watch: {
    name (val) {
      if (!val) return
      if (!val.match(/^u-/)) {
        this.name = 'u-' + val
      }
    }
  },
  methods: {
    open (data) {
      if (data) {
        this.editKey = data.editKey
        this.name = data.name
        this.code = data.code
      } else {
        this.editKey = null
      }
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    onCmCodeChange (code) {
      this.code = code
    },
    submit () {
      if (this.editKey) this.edit()
      else this.save()
    },
    async save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      await this.savePropsDesc()

      db.components.create(this.name, this.code)
        .then(() => {
          this.inProgress = false
          this.name = null
          this.code = `<template>\n\t<div>\n\t</div>\n</template>\n`

          this.close()

          this.$nextTick(() => {
            this.$v.$reset()
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    edit () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      db.components.edit(this.editKey, this.name, this.code)
        .then(() => {
          this.inProgress = false

          this.$nextTick(() => {
            this.$v.$reset()
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async savePropsDesc () {
      const c = httpVueLoader(
        "data:text/plain," + encodeURIComponent(this.code)
      );

      const props = (await c()).props

      if (props) {
        const propsDesc = {}

        for (let propKey in props) {
          const prop = props[propKey]

          switch (prop.type.name) {
            case 'String':
              propsDesc[propKey] = {
                type: 'String',
              }
              break
            case 'Number':
              propsDesc[propKey] = {
                type: 'Number'
              }
              break
            case 'Boolean':
              propsDesc[propKey] = {
                type: 'Boolean'
              }
              break
            case 'Array':
              propsDesc[propKey] = {
                type: 'Array'
              }
              break
            case 'Object':
              propsDesc[propKey] = {
                type: 'Object'
              }
              break
            case 'Date':
              propsDesc[propKey] = {
                type: 'Date'
              }
              break
            case 'Function':
              propsDesc[propKey] = {
                type: 'Function'
              }
              break
            case 'Symbol':
              propsDesc[propKey] = {
                type: 'Symbol'
              }
              break
          }
        }

        db.components.savePropsDesc(this.name, JSON.stringify(propsDesc))
      }
    }
  },
  validations: {
    name: {
      isUnique (val) {
        if (this.editKey) return true
        if (_.find(this.components, { name: val })) return false
        return true
      },
      required,
      alphaNum
    }
  }
}
</script>
